import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { DEVELOPMENT_MEMBERSHIP_PORTAL_FEATURE_GROUP } from './group';

export const DEVELOPMENT_MEMBERSHIP_PORTAL_FEATURES = {
  ACCESS: {
    guid: '6432313d-35c0-4e93-b355-006720bb0001',
    name: 'development:membership-portal:access',
    description: 'Access the Membership Portal development tool',
    action: 'read',
    product: 'app',
    parentGuid: DEVELOPMENT_MEMBERSHIP_PORTAL_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DEVELOPMENT_MEMBERSHIP_PORTAL_FEATURE_GROUP } from './group';

export const DEVELOPMENT_MEMBERSHIP_PORTAL_MODULE: FeatureModule = {
  product: 'app',
  groups: [DEVELOPMENT_MEMBERSHIP_PORTAL_FEATURE_GROUP],
  features: featureList(DEVELOPMENT_MEMBERSHIP_PORTAL_FEATURES),
};
